import { takeEvery, put, call } from "redux-saga/effects"

import { REQUEST_PASSWORD_EMAIL, RESET_PASSWORD_EMAIL } from './actionTypes'
import { requestPasswordEmailSuccess, requestPasswordEmailFailed, resetPasswordEmailSuccess, resetPasswordEmailFailed } from './actions'

import { requestPasswordEmailApi, resetPasswordEmailApi } from "../../../helpers/api/api"

function* requestPasswordEmail({ payload: email , meta }) {
    try {
        let data = {
            email,
            redirect_url: "https://parent.smartht.co.uk"
        }
        const response = yield call(requestPasswordEmailApi,data)
        yield put(requestPasswordEmailSuccess(response, meta))
    }
    catch(error) {
        const {message}=error.response.data
        yield put(requestPasswordEmailFailed(message, meta))
    }
}

function* resetPasswordEmail({ payload: data , meta }) {
    try {
        const response = yield call(resetPasswordEmailApi,data)
       yield put(resetPasswordEmailSuccess(response, meta))
    }
    catch(error) {
        const {message}=error.response.data
        yield put(resetPasswordEmailFailed(message, meta))
    }
}

function* ResetPasswordSaga() {
    yield takeEvery(REQUEST_PASSWORD_EMAIL, requestPasswordEmail)
    yield takeEvery(RESET_PASSWORD_EMAIL, resetPasswordEmail)
}

export default ResetPasswordSaga